export default __webpack_public_path__ + "static/media/AngelDAO.493c7ab2.gif";